<template>
  <div class="pedido-paquete">
    <h3>Registrar pedido de exámenes por paquete</h3>
    <p class="sub">Atención #{{ idAtencion }}</p>

    <!-- Selector de paquete -->
    <div class="form-row">
      <label>Paquete de exámenes *</label>
      <select v-model="idPaqueteSeleccionado" @change="cargarDetalle">
        <option value="">-- Seleccionar paquete --</option>
        <option v-for="p in paquetes" :key="p.idPaquete" :value="p.idPaquete">
          {{ p.nombre }}
        </option>
      </select>
    </div>

    <!-- Vista previa de exámenes del paquete -->
    <div v-if="detallePaquete.length" class="preview">
      <p class="preview-title">
        Exámenes incluidos ({{ detallePaquete.length }}):
      </p>
      <ul>
        <li v-for="d in detallePaquete" :key="d.idExamen">
          {{ d.nombreExamen }}
          <span v-if="d.obligatorio" class="badge-req">Obligatorio</span>
        </li>
      </ul>
    </div>

    <!-- Observación del pedido -->
    <div class="form-row">
      <label>Observación del pedido</label>
      <input
        v-model="observacion"
        placeholder="Indicaciones adicionales para laboratorio o imagen..."
      />
    </div>

    <!-- Tratamiento (tabla tratamiento) -->
    <div class="form-row">
      <label>
        Tratamiento
        <span class="hint-inline">(opcional — crea registro en tabla tratamiento)</span>
      </label>
      <div class="trat-row">
        <select v-model="tipoTratamiento" style="width: 160px; flex-shrink: 0;">
          <option value="">Tipo</option>
          <option value="LAB">Laboratorio</option>
          <option value="IMG">Imagen</option>
          <option value="OTRO">Otro</option>
        </select>
        <input
          v-model="observacionTratamiento"
          placeholder="Descripción del tratamiento o indicación médica..."
          style="flex: 1;"
        />
      </div>
    </div>

    <!-- Acciones -->
    <div class="footer">
      <button class="btn-secondary" @click="$emit('cancelar')">Cancelar</button>
      <button
        class="btn-primary"
        :disabled="!idPaqueteSeleccionado || registrando"
        @click="registrar"
      >
        {{ registrando ? 'Registrando...' : 'Registrar pedido' }}
      </button>
    </div>

    <!-- Resultado -->
    <div v-if="resultado" class="resultado">
      <p class="ok">
        ✓ Pedido #{{ resultado.idPedido }} registrado —
        {{ resultado.totalExamenes }} examen(s)
        <span v-if="resultado.idTratamiento">
          · Tratamiento #{{ resultado.idTratamiento }} creado
        </span>
      </p>
      <table class="tabla-det">
        <thead>
          <tr><th>Examen</th><th>Estado</th></tr>
        </thead>
        <tbody>
          <tr v-for="d in resultado.detalle" :key="d.idPedidoDet">
            <td>{{ d.nombreExamen }}</td>
            <td>Pendiente</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { paqueteService, pedidoService } from '@/services/paqueteService'

export default {
  name: 'PedidoPaquete',
  props: {
    idAtencion: { type: Number, required: true },
    tipo:       { type: String, required: true },
  },
  emits: ['cancelar', 'registrado'],
  data() {
    return {
      paquetes:               [],
      idPaqueteSeleccionado:  '',
      detallePaquete:         [],
      observacion:            '',
      observacionTratamiento: '',
      tipoTratamiento:        '',
      registrando:            false,
      resultado:              null,
    }
  },
  async mounted() {
    const { data } = await paqueteService.listar()
    this.paquetes = data
  },
  methods: {
    async cargarDetalle() {
      if (!this.idPaqueteSeleccionado) {
        this.detallePaquete = []
        return
      }
      const { data } = await paqueteService.obtener(this.idPaqueteSeleccionado)
      this.detallePaquete = data.detalles ?? []
    },
    async registrar() {
      this.registrando = true
      this.resultado   = null
      try {
        const { data } = await pedidoService.registrarDesdePaquete({
          idAtencion:             this.idAtencion,
          idPaquete:              this.idPaqueteSeleccionado,
          tipo:                   this.tipo,
          observacion:            this.observacion             || null,
          observacionTratamiento: this.observacionTratamiento  || null,
          tipoTratamiento:        this.tipoTratamiento          || null,
        })
        this.resultado = data
        this.$emit('registrado', data)
      } catch (e) {
        alert('Error: ' + (e.response?.data?.message ?? e.message))
      } finally {
        this.registrando = false
      }
    },
  },
}
</script>

<style scoped>
.pedido-paquete { padding: 20px; }
h3  { margin: 0 0 4px; font-size: 16px; }
.sub{ color: #6b7280; font-size: 13px; margin: 0 0 20px; }
.form-row { margin-bottom: 16px; }
.form-row label { display: block; font-size: 13px; font-weight: 500;
                  margin-bottom: 4px; color: #374151; }
.form-row input,
.form-row select { padding: 8px 10px; border: 1px solid #d1d5db;
                   border-radius: 6px; font-size: 14px; box-sizing: border-box; }
.form-row input  { width: 100%; }
.hint-inline { font-size: 11px; color: #9ca3af; font-weight: 400; margin-left: 4px; }
.trat-row    { display: flex; gap: 8px; align-items: center; }
.preview     { background: #f0f9ff; border: 1px solid #bae6fd;
               border-radius: 8px; padding: 12px 16px; margin-bottom: 16px; }
.preview-title { font-size: 13px; font-weight: 500; margin: 0 0 8px; }
.preview ul  { margin: 0; padding-left: 18px; }
.preview li  { font-size: 13px; padding: 2px 0; display: flex;
               align-items: center; gap: 8px; }
.badge-req   { background: #dbeafe; color: #1d4ed8;
               padding: 1px 6px; border-radius: 10px; font-size: 11px; }
.footer      { display: flex; justify-content: flex-end; gap: 10px; margin-top: 8px; }
.btn-primary { background: #2563eb; color: #fff; border: none;
               padding: 8px 20px; border-radius: 6px; cursor: pointer; }
.btn-primary:disabled { opacity: .5; cursor: not-allowed; }
.btn-secondary{ background: #f3f4f6; border: 1px solid #d1d5db;
                padding: 8px 16px; border-radius: 6px; cursor: pointer; }
.resultado   { margin-top: 20px; }
.ok  { color: #065f46; background: #d1fae5; padding: 10px;
       border-radius: 6px; font-size: 14px; margin-bottom: 12px; }
.tabla-det   { width: 100%; border-collapse: collapse; font-size: 13px; }
.tabla-det th,
.tabla-det td { padding: 8px 10px; border-bottom: 1px solid #e5e7eb; text-align: left; }
.tabla-det th { background: #f9fafb; font-weight: 500; }
</style>